import React from 'react';
import PropTypes from 'prop-types';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import Slide from '@material-ui/core/Slide';
import Button from '@material-ui/core/Button';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import ThetaShooting from './shooting/ThetaShooting';
import { I18n } from 'aws-amplify';
import Typography from '@material-ui/core/Typography';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import { withStyles } from '@material-ui/core/styles';
import Snackbar from '@material-ui/core/Snackbar';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import purple from '@material-ui/core/colors/purple';

import "./smartdevice.css";

let odisplayname = undefined;

const styles = theme => ({
  root: {
    backgroundColor: theme.palette.background.paper,
    borderTop: '1px solid #ccc',
  },
  dialogPaper: {
        minHeight: '90vh',
        maxHeight: '100vh',
    },
    colorSwitchBase: {
    color: purple[300],
    '&$colorChecked': {
      color: purple[500],
      '& + $colorBar': {
        backgroundColor: purple[500],
      },
    },
  },
  colorBar: {},
  colorChecked: {},
  iOSSwitchBase: {
    '&$iOSChecked': {
      color: theme.palette.common.white,
      '& + $iOSBar': {
        backgroundColor: '#52d869',
      },
    },
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
      easing: theme.transitions.easing.sharp,
    }),
  },
  iOSChecked: {
    transform: 'translateX(15px)',
    '& + $iOSBar': {
      opacity: 1,
      border: 'none',
    },
  },
  iOSBar: {
    borderRadius: 13,
    width: 42,
    height: 26,
    marginTop: -13,
    marginLeft: -21,
    border: 'solid 1px',
    borderColor: theme.palette.grey[400],
    backgroundColor: theme.palette.grey[50],
    opacity: 1,
    transition: theme.transitions.create(['background-color', 'border']),
  },
  iOSIcon: {
    width: 24,
    height: 24,
  },
  iOSIconChecked: {
    boxShadow: theme.shadows[1],
  }
});

function Transition(props) {
  return <Slide direction="up" {...props} />;
}

class ThetaBind extends React.Component {
      state = {
        serialnumber: undefined,
        options: undefined,
        updateFlg: false,
        confirm: false,
    　};
    　
      componentDidMount() {
        this.props.onShootingMount(this.props.item.devicename);
        
        if (odisplayname === undefined) {
          odisplayname = this.props.item.displayname;
        }
      }
      
      componentWillReceiveProps(nextProps) {
        let _options = this.state.options;

        if (nextProps.getOptions !== undefined) {
          _options = nextProps.getOptions;
        }
        
        this.setState({
          options: _options
        });
        
        if (nextProps.uploadCheck !== undefined &&
          nextProps.uploadCheck !== this.props.uploadCheck) {
          this.setState({
            uploadCheck: nextProps.uploadCheck
          });
        }
      }    

      handleClickOpen = () => {
          if (odisplayname !== this.props.item.displayname) {
            odisplayname = this.props.item.displayname;
          }
          this.props.onPostDate(this.props.ranking,this.props.item,false,this.props.item.uploadCheck);
          this.props.updateState({
              open: true,
              bitem: this.props.item
          });
      };
    
      handleClose = (item) => {
          this.props.updateState({
              open: false,
              bitem: this.props.item
          });
      };
    　
      handleBack = () => {
          if (odisplayname !== this.props.item.displayname) {
            odisplayname = this.props.item.displayname;
            // this.props.onPostDate(this.props.ranking,this.props.item,false,this.props.item.uploadCheck);
          }

          this.props.updateState({
              open: false,
              bitem: undefined,
              ranking: this.props.ranking,
              uploadCheck: this.props.item.uploadCheck
          });
      };
      
      handleChange = event => {
          let updateitem = this.props.item;
          updateitem.displayname = event.target.value;
          this.setState({
              item: updateitem,
              updateFlg: true
          });
      };
      
      handleChange2 = (ranking,item) => event => {
        this.props.updateState({
              uploadCheck: event.target.checked,
          });
          
        if (item.uploadCheck !== event.target.checked){
          item.uploadCheck = event.target.checked;
        }
        
        this.props.onPostDate(ranking,item,false,event.target.checked);
      };

      deleteTheta = (ranking, item) => {
          this.props.updateState({
              bitem: undefined
          });
          this.props.onPostDate(ranking, item,true,this.props.item.uploadCheck);
          this.props.componentDidMount();
      };
      
      handleClickConfirm = () => {
        this.setState({ confirm: true });
      };
    
      handleCloseConfirm = () => {
        this.setState({ confirm: false });
      };
      
    render() {
        const { classes,ranking, item, videoJsOptions,open,value,error } = this.props;
        const { options } = this.state;

    return (
        <div className="App">
        {(() => {
            if (error) {
                return <p>{I18n.get("error")}</p>;
            } else {
                return (
                <ol>
                <ul className="header_short header_medium">
                <li className="back_button">
                  <Button size="small" onClick={this.handleBack} >
                    <KeyboardArrowLeft />
                    <p className="back">Back</p>
                  </Button>
                </li>
                <li className="title_short"><nobr><p className="title_medium">{I18n.get("SmartDevice")}</p></nobr></li>
              　</ul>
                <div className="bindedtheta">
                <p className="bindedleft">{I18n.get("register name")}</p>
                <div className="bindedleftmargin">
    　　          <TextField id={`DisplayName-${item.serialnumber}`}
    　　            className="bindedright"
                  placeholder="DisplayName"
                  style={{width: '150px' }}
                  value={`${item.displayname}`}
                  onChange={this.handleChange}/>
                </div>
                </div>
                <div className={classes.root}>
                <List disablePadding={true}>
                  <ListItem
                    role={undefined}
                    dense
                    button
                    divider={true}
                    disabled={(options === undefined || options.power === 'off')?true:false}
                    onClick={this.handleClickOpen}
                    >
                    <ListItemText 
                    className="theta_bind"
                    disableTypography
                    primary={<Typography type="body2" style={{ color: '#0088bd',fontSize:'small' }}  ><p className="move">{I18n.get("move")}</p></Typography>}
                    />
                  </ListItem>
                  <Dialog
                    classes={{ paper: classes.dialogPaper }}
                    fullScreen
                    open={open}
                    onClose={this.handleClose}
                    TransitionComponent={Transition}
                   >
                   <ThetaShooting 
                    serialnumber={ item.serialnumber }
                    devicename={item.devicename}
                    getOptions={options}
                    videoJsOptions={videoJsOptions}
                    value={value}
                    onShootingMount={this.props.onShootingMount}
                    onShootingPostDate={this.props.onShootingPostDate}
                    updateState={this.props.updateState}
                    handleClose={this.handleClose}
                  />
                  </Dialog>
                  <ListItem
                    role={undefined}
                    dense
                    button
                    divider={true}
                    onClick={this.handleClickConfirm}
                  >
                  <ListItemText 
                  className="theta_bind"
                  disableTypography
                  primary={<Typography type="body2" style={{ color: '#d0021b',fontSize:'small' }}  ><p className="delete">{I18n.get("delete")}</p></Typography>}
                  />
                  </ListItem>
                  <Dialog
                    open={this.state.confirm}
                    onClose={this.handleClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                  >
                    <DialogTitle id="alert-dialog-title">{I18n.get("confirm delete")}</DialogTitle>
                    <DialogActions >
                      <Button onClick={this.handleCloseConfirm} color="primary">
                        {I18n.get("no")}
                      </Button>
                      <Button onClick={() => {this.deleteTheta(ranking, item)}} color="primary">
                        {I18n.get("yes")}
                      </Button>
                    </DialogActions>
                  </Dialog>
                </List>
                </div>
                
                <div className="parent_cloudupload">
                <div className="left">{I18n.get("use CloudUpload")}</div>
                <div className="right">
                <FormGroup row>
                  <FormControlLabel 
                    control={
                      <Switch
                        classes={{
                          switchBase: classes.iOSSwitchBase,
                          bar: classes.iOSBar,
                          icon: classes.iOSIcon,
                          iconChecked: classes.iOSIconChecked,
                          checked: classes.iOSChecked,
                        }}
                        disabled={(options === undefined || options.power === 'off')?true:false}
                        checked={item.uploadCheck}
                        onChange={this.handleChange2(ranking,item)}
                      />
                    }
                  />
                </FormGroup>
                </div>
                </div>
                <div className="lower_div">
                <p className="lower_introduction">{I18n.get("lower introduction")}</p>
                </div>
                
                <Snackbar
                  open={!open && (options === undefined || options.power === 'off')?true:false}
                  message={I18n.get("plugin off")}
                >
                </Snackbar>
                </ol>
              );
            }
        })()}
        </div>
        );
    }
}

ThetaBind.propTypes = {

    item: PropTypes.shape({
            code: PropTypes.string,
            name: PropTypes.string,
            url: PropTypes.string,
            imageUrl: PropTypes.string
        }),
    error: PropTypes.bool.isRequired
};

export default withStyles(styles)(ThetaBind);



// WEBPACK FOOTER //
// ./src/components/ThetaBind.js